/* M2 — тексты макета дословно (mockdata S7/M2) и правило вердикта (спека §2.1). */

export const NO_COMMENTS = "Комментариев к ячейкам нет — при вердикте «нужны правки» студент не поймёт, что чинить.";

/** Чек-лист ревью: совет ментору, не гейт и студенту не показывается. id = index + 1. */
export const CHECKLIST = [
  "Разбиение данных корректно, утечки из теста нет",
  "Препроцессор обучается только на train",
  "Результат воспроизводим: фиксированный seed, порядок ячеек",
  "Решение читается: имена по смыслу, без копипасты",
];

/** Сниппеты композера: клик ЗАМЕНЯЕТ черновик, а не дописывает. */
export const SNIPPETS = [
  { label: "утечка данных", text: "Препроцессор обучается на всей выборке — перенеси fit только на train." },
  { label: "именование", text: "Имя переменной ничего не говорит о содержимом. Назови по смыслу." },
  { label: "сложность", text: "Проверка через список даёт O(n²). Возьми множество." },
];

export type Verdict = "accept" | "revise";
export const VERDICT_LABEL: Record<Verdict, string> = { accept: "принять", revise: "нужны правки" };
export const SEND_LABEL: Record<Verdict, string> = { accept: "принять работу", revise: "вернуть с правками" };
export const SEND_NOTE: Record<Verdict, string> = {
  accept: "Студент увидит вердикт и сводку. Гейт шага пересчитается автоматически.",
  revise: "Возврат уходит с перечнем из комментариев к ячейкам — студент видит, что именно чинить.",
};
export const API_STATUS: Record<Verdict, "accepted" | "changes_requested"> = { accept: "accepted", revise: "changes_requested" };

/** «принять» — всегда; «вернуть» — только при ≥ 1 корневом комментарии. */
export const canSend = (verdict: Verdict, rootComments: number) => verdict === "accept" || rootComments > 0;

/** «3-я итерация по одной причине» — сигнал на созвон (CLAUDE.md правило 10). */
export const flagText = (count: number, reason: string) => `${count}-я итерация по одной причине («${reason}») — повод на созвон, а не ещё один текст.`;
